import { inject, Injectable } from '@angular/core';
import {
  catchError,
  filter,
  from,
  map,
  Observable,
  of,
  shareReplay,
  switchMap,
  take,
  timeout,
} from 'rxjs';
import { MapsService } from './maps.service';

const DEFAULT_GEOCODE_TIMEOUT_MS = 3000;

@Injectable({ providedIn: 'root' })
export class GeocodingService {
  private readonly mapsService = inject(MapsService);

  private readonly geocoder$: Observable<google.maps.Geocoder> = this.mapsService.load().pipe(
    filter((loaded) => loaded === true),
    take(1),
    map(() => new google.maps.Geocoder()),
    shareReplay(1),
  );

  geocodeAddress(
    query: string | null | undefined,
    timeoutMs: number = DEFAULT_GEOCODE_TIMEOUT_MS,
  ): Observable<google.maps.GeocoderResult | null> {
    const trimmed = query?.trim();
    if (!trimmed) return of(null);
    return this.geocoder$.pipe(
      switchMap((geocoder) =>
        from(geocoder.geocode({ address: trimmed })).pipe(
          timeout(timeoutMs),
          map((response) => response.results?.[0] ?? null),
          catchError(() => of(null)),
        ),
      ),
    );
  }
}
